export default __webpack_public_path__ + "static/media/Mark of the Endless Sands.dcb587c9.jpg";